import React, { useState, useEffect } from "react";
import { Navigate, useNavigate, useLocation, Form } from "react-router-dom";
import Loader from "../../../Common/Loader/loader";
import { innergetActiveCircleReport, innergetActiveCircleReportTotal, innergetAllZoneWiseReport, innergetCircleInActiveReport, innergetCircleInActiveReportTotal, innergetCondemnedReportCircleWise, innergetCondemnedReportCircleWiseCircle, innergetNotReportedAtWardCircle, innergetNotReportedAtWardCircleTotal, innergetReportedAtWardAndTSCircle, innergetReportedAtWardAndTSCircleTotal, innergetReportedAtWardCircleWise, innergetReportedAtWardCircleWiseTotal, innergetReportedAtWardNotTSCircle, innergetReportedAtWardNotTSCircleTotal, innergetReportedTsNotWardReportCircleWise, innergetReportedTsNotWardReportCircleWiseTotal, innergetTotalReportCircleWise, innergetTotalReportCircleWiseCircle, innergetUnderRepairReportCircleWise, innergetUnderRepairReportCircleWiseTotal } from "../../../Apis/satReportsApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";

import ExcelJS from "exceljs";
import { Field, Formik } from "formik";
import useFilterStore from "./store/useFilterStore";
import { formattedDate, getCurrentDateTime, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";

const ViewZonedetailedreport = () => {
  const {
    zoneWiseFilters
  } = useFilterStore();
  
  const getCurrentDate = new Date().toLocaleDateString("en-CA");
  const navigate = useNavigate();
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [getZoneInnerReport, setgetZoneInnerReport] = useState([]);
  const [data, setData] = useState(null);
  const location = useLocation()
  const {ZoneIds, Date: SelectedDate, VehicleTypeId, ownerTypeId, vehicleId, transferStationId, vehicleNumber} = location.state;
  const [satList, setSatList] = useState([]);
  const [filterOriginalData, setFilterOriginalData] = useState([]);

  // const data = location.state
  const [zonesData, setZonesData] = useState([]);

  useEffect(() => {
    const fetchInnerReport = async () => {
      setIsLoading(true);
      try {
        const response = await innergetAllZoneWiseReport({
          ZoneIds,
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId,
          ownerType: ownerTypeId,
          vehicleId,
          transferStationId,
          vehicleNumber,
        });
        setSatList(response);
        setFilterOriginalData(response);
      } catch (error) {
        console.error("Error fetching zone inner report:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInnerReport();
  }, [ZoneIds, SelectedDate, VehicleTypeId, ownerTypeId, vehicleId, transferStationId, vehicleNumber, getCurrentDate]);


  const satReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      //   sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
     {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      //   sortable: true,
      //format: (row, rowIndex) => rowIndex + 1,
      width: "120px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleZoneClick(row["circleId"])}
        >
          {row["circleName"]}
        </span>
      ),
      width: "120px",
      //   sortable: true,
    },
    {
      name: <>Total<br />Vehicles</>,
      selector: (row) => row["totalVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalCircleVehicleClickCircle();
            } else {
              handleTotalCircleVehicleClick(row["circleId"]);
            }
          }}
        >
          {row["totalVehicles"]}
        </span>
      ),
      //  sortable: true,
      width: "120px",
    },
    {
      name: <>Condemned<br />Vehicles</>,
      selector: (row) => row["condemnedVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleCondemnedCircleClickTotal();
            } else {
              handleCondemnedCircleClick(row["circleId"]);
            }
          }}
        >
          {row["condemnedVehicles"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>Repair<br />Vehicles</>,
      selector: (row) => row["repairVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleUnderRepaiCircleClickTotal();
            } else {
              handleUnderRepaiCircleClick(row["circleId"]);
            }
          }}
        >
          {row["repairVehicles"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    // {
    //   name: "totalInActive",
    //   selector: (row) => (
    //     <span
    //      style={{ color: "blue", cursor: "pointer" }}
    //       onClick={() => handleZoneClick(row["circleId"])} >{row["totalInActive"]}</span>
    //   ),
    //   sortable: true,
    // },
    {
      name: <>Total InActive Vehicles</>,
      selector: (row) => row["totalInActive"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleInActiveCicleClickTotal();
            } else {
              handleInActiveCicleClick(row["circleId"]);
            }
          }}
        >
          {row["totalInActive"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: <>Active Vehicles</>,
      selector: (row) => row["activeVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleActiveCircleClickTotal();
            } else {
              handleActiveCircleClick(row["circleId"]);
            }
          }}
        >
          {row["activeVehicles"]}
        </span>
      ),
      //     sortable: true,
      width: "150px",
    },

    {
      name: <>Reported at Ward</>,
      selector: (row) => row["reportedAtWard"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtWardCircleClickTotal();
            } else {
              handleReportedAtWardCircleClick(row["circleId"]);
            }
          }}
        >
          {row["reportedAtWard"]}
        </span>
      ),
      width: "150px",
      //    sortable: true,
    },
    {
      name: <>Not Reported at Ward</>,
      selector: (row) => row["notReportedAtWard"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleNotReportedAtWardCircleClickTotal();
            } else {
              handleNotReportedAtWardCircleClick(row["circleId"]);
            }
          }}
        >
          {row["notReportedAtWard"]}
        </span>
      ),
      //   sortable: true,
      width: "150px",
    },
    {
      name: <>Reported at Ward & TS</>,
      selector: (row) => row["reportedAtWardAndTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtWardAndTSCircleClickTotal();
            } else {
              handleReportedAtWardAndTSCircleClick(row["circleId"]);
            }
          }}
        >
          {row["reportedAtWardAndTS"]}
        </span>
      ),
      //   sortable: true,
      width: "150px",
    },
    {
      name: <>Reported at Ward Not TS</>,
      selector: (row) => row["reportedAtWardNotTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtWardNotTSCircleClickTotal();
            } else {
              handleReportedAtWardNotTSCircleClick(row["circleId"]);
            }
          }}
        >
          {row["reportedAtWardNotTS"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>Reported at TS Not Ward</>,
      selector: (row) => row["reportedAtTSNotWard"],
      cell: (row) => (
        // <span
        //   style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleReportedTsNotWardCircle(row["circleId"])}
        // >
        //   {row["reportedAtTSNotWard"]}
        // </span>
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedTsNotWardCircleTotal();
            } else {
              handleReportedTsNotWardCircle(row["circleId"]);
            }
          }}
        >
          {row["reportedAtTSNotWard"]}
        </span>
      ),
      //    sortable: true,
      // width: "120px",
    },
  ];


  const handleReportedTsNotWardCircle = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        navigate("/reported-ts-notward-circle", { state: {
          CircleId: CircleId,
          date: SelectedDate || getCurrentDate,
          vehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
          fromDate: SelectedDate,
        } });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleReportedTsNotWardCircleTotal = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
          navigate("/reported-ts-notward-circle-total", { state: {
            CircleId: CircleId,
            date: SelectedDate || getCurrentDate,
            vehicleTypeId: VehicleTypeId,
            ownerTypeId: ownerTypeId,
            vehicleId: vehicleId,
            transferStationId: transferStationId,
            vehicleNumber: vehicleNumber,
            fromDate: SelectedDate,
          } });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
  
    const handleCondemnedCircleClick = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetCondemnedReportCircleWise({
          CircleId: CircleId,
          CollectionTypeId: "1",
          VehicleStatusId: "2",
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-condemned-report", { state: {data:response} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleCondemnedCircleClickTotal = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetCondemnedReportCircleWiseCircle({
          CollectionTypeId: "1",
          VehicleStatusId: "2",
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-condemned-circle-report", { state: {data:response} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleTotalCircleVehicleClick = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetTotalReportCircleWise({
          CircleId: CircleId,
          CollectionTypeId: "1",
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
  
        navigate("/sat-circle-total-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleTotalCircleVehicleClickCircle = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetTotalReportCircleWiseCircle({
          CollectionTypeId: "1",
          allCircles: true,
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/sat-circle-total-wise-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleActiveCircleClick = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetActiveCircleReport({
          CircleId: CircleId,
          CollectionTypeId: "1",
          IsActive: true,
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-active-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleActiveCircleClickTotal = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetActiveCircleReportTotal({
          CollectionTypeId: "1",
          IsActive: true,
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-active-total-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleInActiveCicleClick = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetCircleInActiveReport({
          CollectionTypeId: "1",
          CircleId: CircleId,
          VehicleStatusId: "1",
          IsActive: false,
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-inactive-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleInActiveCicleClickTotal = async (CircleId) => {
      try {
        setIsOptionsLoading(true);
        const response = await innergetCircleInActiveReportTotal({
          CollectionTypeId: "1",
          VehicleStatusId: "1",
          IsActive: false,
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerType: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-inactive-total-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleUnderRepaiCircleClick = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        const response = await innergetUnderRepairReportCircleWise({
          CircleId: CircleId,
          VehicleStatusId: "3",
  
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-under-repair-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
  
    const handleUnderRepaiCircleClickTotal = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        const response = await innergetUnderRepairReportCircleWiseTotal({
          VehicleStatusId: "3",
  
          Date: SelectedDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/circle-under-repair-total-report", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleReportedAtWardAndTSCircleClick = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        const response = await innergetReportedAtWardAndTSCircle({
          CircleId: CircleId,
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/reported-wardts-circle",{ state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleReportedAtWardAndTSCircleClickTotal = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        const response = await innergetReportedAtWardAndTSCircleTotal({
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/reported-wardts-circle-total", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleNotReportedAtWardCircleClick = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        // const currentDate = new SelectedDate().toLocaleDateString("en-CA");
  
        const response = await innergetNotReportedAtWardCircle({
          CircleId: CircleId,
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/not-reported-ward-circle", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleNotReportedAtWardCircleClickTotal = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        const response = await innergetNotReportedAtWardCircleTotal({
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/not-reported-ward-circle-total",{ state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleReportedAtWardNotTSCircleClick = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        const response = await innergetReportedAtWardNotTSCircle({
          CircleId: CircleId,
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/reported-ward-notts-circle", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleReportedAtWardNotTSCircleClickTotal = async (CircleId) => {
      try {
        //console.log(formInput,'forminput2')
        setIsOptionsLoading(true);
        const response = await innergetReportedAtWardNotTSCircleTotal({
          Date: SelectedDate || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/reported-ward-notts-circle-total", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
    const handleReportedAtWardCircleClick = async (row) => {
      // console.log(row)
      const startTime = "00:00";
      const endTime = "23:59";
      const Date = SelectedDate
        ? SelectedDate
        : getCurrentDateTime();
      // Concatenate start and end times with the date
      const startDate = `${Date}T${startTime}`;
      const endDate = `${Date}T${endTime}`;
      try {
        setIsOptionsLoading(true);
        const response = await innergetReportedAtWardCircleWise({
          startDate: startDate,
          endDate: endDate,
          CircleId: row,
          allCircles: true,
  
          Date: Date || getCurrentDate,
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/reported-ward-circle", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
  
    const handleReportedAtWardCircleClickTotal = async (row) => {
      const startTime = "00:00";
      const endTime = "23:59";
      // Concatenate start and end times with the date
      const Date = Date
        ? Date
        : getCurrentDateTime();
      const startDate = `${Date}T${startTime}`;
      const endDate = `${Date}T${endTime}`;
      try {
        setIsOptionsLoading(true);
        const response = await innergetReportedAtWardCircleWiseTotal({
          startDate: startDate,
          endDate: endDate,
  
          VehicleTypeId: VehicleTypeId,
          ownerTypeId: ownerTypeId,
          vehicleId: vehicleId,
          transferStationId: transferStationId,
          vehicleNumber: vehicleNumber,
        });
        navigate("/reported-ward-circle-total", { state: {data:response,fromDate:SelectedDate} });
      } catch (error) {
        console.error("Error fetching vehicle wise report:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };
  
   
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SATs Circle Wise Vehicle Report on ${zoneWiseFilters.date ? formattedDate(zoneWiseFilters.date) : getCurrentISTDate()} - (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 5);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "corporationName",
      "Circle Name",
      "Total Vehicles",
      "Condemned Vehicles",
      "Under Repair Vehicles",
      "Active Vehicles",
      "Total InActive Vehicles",
      "Reported At Ward",
      "Not Reported At Ward",
      "Reported At Ward And TS",
      " Reported At Ward Not Ts",
      "Reported At TS Not Ward",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 12) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    satList?.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.corporationName?? "N/A",
        item.circleName?? "N/A",
        item.totalVehicles?? "N/A",
        item.condemnedVehicles?? "N/A",
        item.repairVehicles?? "N/A",
        item.activeVehicles?? "N/A",
        item.totalInActive?? "N/A",
        item.reportedAtWard?? "N/A",
        item.notReportedAtWard?? "N/A",
        item.reportedAtWardAndTS?? "N/A",
        item.reportedAtWardNotTS?? "N/A",
        item.reportedAtTSNotWard?? "N/A",

      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 12) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 22 },
      { width: 25 },
      { width: 25 },
      { width: 21 },
      { width: 25 },
      { width: 20 },
      { width: 23 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CircleWiseVehicleReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  // Filters
  const filterFields = {
    searchCircle: "",
  };

  const searchSCVCircleHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = (Array.isArray(filterOriginalData) ? filterOriginalData : []).filter(item => item?.circleName?.toLowerCase()?.includes(term));
    setSatList(data);
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header"></div>
            <div class="row" style={{ textAlign: "justify" }}>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-4">
                      <div className="form-group">
                      <input
                        placeholder="Search Circle"
                        type="text"
                        className="form-control bg-white"
                        onInput={searchSCVCircleHandler}
                      />
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex justify-content-end mt-3 mb-3">
                      <button className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>
                      <button className="btn btn-excel"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>

                    </div>
                  </div>
                </div>
                <div className="top-header">
                  <span>
                    SATs Circle Wise Detailed Report on {zoneWiseFilters.date ? formattedDate(zoneWiseFilters.date) : getCurrentISTDate()} -(at {getCurrentDateTime1()})
                  </span>
                </div>
                {satList &&
                  <CustomDataTable
                    data={satList}
                    columns={satReportColumns}
                  // headers={headers}
                  // link={true}
                  // search={true}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default ViewZonedetailedreport;
